import { useMemo } from "react";
import { useParams } from "react-router";
import { useTypedSelector } from "../../../../store/reducers/use-typed-selector";
import { EPermissions } from "../../../../types/working-model";
import { intersection } from "underscore";

const canEditEvents = [EPermissions.Admin, EPermissions.Owner, EPermissions.Sitebuilder, EPermissions.GroupAdmin, EPermissions.Producer];

export const useReadonlyMode = (isSession = false) => {
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const workingSession = useTypedSelector(state => state.CreateSessionReducer.workingSession);
	const user = useTypedSelector(state => state.AuthReducer.user);
	const { language } = useParams() as { language?: string };

	const isReadOnly = useMemo(() => {
		if (!workingEvent || !language || !user) return false;

		// if this user is not of a user type that can edit events, they can only view them.
		if (!intersection(user.channels[user.active_channel], canEditEvents).length) {
			return true;
		}

		if (isSession) {
			if (!workingSession) return true;

			// if this event is using the new translations
			return workingEvent.settings.translation_version === 2
				// not the session default language
				&& workingSession.default_language !== language;
		}

		// if this event is using the new translations
		return Boolean(workingEvent.settings.translation_version === 2
			// event default language exists
			&& workingEvent.settings.i18n
			// event default language is not the selected language
			&& workingEvent.settings.i18n?.base !== language);
	}, [workingEvent, language, isSession, workingSession, user]);

	return isReadOnly;
};